"use client";

import { LanguageContext } from "@/context/languageContext";
import styles from "@/styles/modules/components/vouchers/vouchersList.module.scss";
import { Voucher } from "@/types/wordpress";
import { translate } from "@/utils/translate";
import Image from "next/image";
import Link from "next/link";
import { useContext } from "react";

interface VouchersListProps {
  vouchers: Voucher[];
}

export default function VouchersList({ vouchers }: VouchersListProps) {
  const { language } = useContext(LanguageContext);

  return (
    <section className={styles.vouchersList}>
      <div className={styles.vouchersListContainer}>
        {vouchers.map((item, i) => (
          <article key={i}>
            {item.featuredImage && (
              <div className={styles.image}>
                <Link href={`/${language}/vouchers/${item.slug}`}>
                  <Image
                    alt={
                      item.featuredImage.node.altText ||
                      "Imperial Riding School"
                    }
                    src={item.featuredImage.node.link}
                    width={item.featuredImage.node.mediaDetails.width}
                    height={item.featuredImage.node.mediaDetails.height}
                  />
                </Link>
              </div>
            )}
            <div className={styles.info}>
              <div className={styles.text}>
                <h3>{item.title}</h3>
                <p>{item.vouchersContent.date}</p>
              </div>
              <div className={styles.links}>
                <Link href={`/${language}/vouchers/${item.slug}`}>
                  {translate["findOutMore"][language]}
                </Link>
                {item.contentFields.button && (
                  <a
                    href={item.contentFields.button.url}
                    target={item.contentFields.button.target}
                  >
                    {item.contentFields.button.title}
                  </a>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
